import React from 'react';
import PropTypes from 'prop-types';
import PaymentGatewayService from '../../../service/PaymentGatewayService';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';
import SearchBar from '../../searchbar/SearchBar';
import DetailedScheduledInstallmentPlanModal from './DetailedScheduledInstallmentPlanModal';

class ManagedPayView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.searchBar = React.createRef();
    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
    ];
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  getInstallmentPlans(criteria, onCompletion) {
    const InstallmentPlanPromise = PaymentGatewayService.managedpay.searchScheduledInstallmentPlans(criteria)
      .then(response => response.data);

    Promise.all([ InstallmentPlanPromise, ])
      .then(([ InstallmentPlansResultSet, ]) => {
        const installmentHeaders = this.getHeadersFromResultSetData();
        const installmentRows = this.getRowsFromResultSetData(InstallmentPlansResultSet.installmentPlans);
        const installmentPlanData = {
          headers: installmentHeaders,
          rows: installmentRows,
          selectedPlan: null,
        };

        this.setState({
          installmentPlanData,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  }

  getStartedAt(installmentPlan) {
    try {
      const dates = installmentPlan.scheduledCarts
        .map((scheduledCart) => new Date(scheduledCart.cartPaymentRequest.paymentDate))
        .sort((a, b) => b - a);
      return dates[dates.length - 1].toDateString();
    } catch (err) {
      console.error(err);
      return '-';
    }
  }

  getServiceOfferingId(installmentPlan) {
    try {
      return installmentPlan.scheduledCarts[0].cart.subCarts[0].payables[0].serviceOfferingId;
    } catch (err) {
      console.error(err);
      return '-';
    }
  }

  getRowsFromResultSetData(installmentPlanArray) {
    const rows = [];
    installmentPlanArray.forEach((installmentPlan) => {
      const row = [];
      row.push(installmentPlan.scheduledInstallmentPlanId);
      row.push(this.getServiceOfferingId(installmentPlan));
      row.push(this.getStartedAt(installmentPlan));

      rows.push({
        value: row,
        raw: installmentPlan,
      });
    });
    return rows;
  }

  getHeadersFromResultSetData() {
    const headers = [
      {
        value: 'scheduledInstallmentPlanId',
        display: 'ID',
      },
      {
        value: 'serviceOfferingName',
        display: 'Service',
      },
      {
        value: 'startedAt',
        display: 'Started',
      },
    ];
    return (headers);
  }

  onClick(event) {
    this.reset();
    const { search, combo, } = event;
    const { requestedState, } = this.props;
    const criteria = {};

    if (requestedState && !search.value) {
      criteria.customerId = requestedState.id;
    } else {
      criteria[combo.value] = search.value;
    }
    this.getInstallmentPlans(criteria, event.kill);
  }

  onRowSelect(selectedRow) {
    const { installmentPlanData, } = this.state;
    installmentPlanData.rows.forEach((row) => {
      if (row.raw.scheduledInstallmentPlanId === selectedRow.scheduledInstallmentPlanId) {
        installmentPlanData.selectedPlan = row.raw;
      }
    });
    this.setState({
      installmentPlanData,
    });
  }

  reset() {
    this.setState({});
  }

  statefulInitialization(customerId) {
    this.setState({
      customerId,
    });

    const { click, } = this;
    if (click) {
      click();
    }
  }

  showSelectedInstallmentPlanInfo(selectedPlan) {
    const { sendNavigationRequest, } = this.props;
    if (!selectedPlan) {
      return null;
    }
    return (
      <div>
        <p>{`Selected Plan: ${selectedPlan.scheduledInstallmentPlanId}`}</p>
        <hr />
        <DetailedScheduledInstallmentPlanModal
          sendNavigationRequest={sendNavigationRequest}
          scheduledInstallmentPlan={selectedPlan}
        />
      </div>
    );
  }

  getGrid(data, title) {
    if (data == null) {
      return null;
    }
    const {
      rows = [], headers = [], selectedPlan,
    } = data;
    if (headers.length === 0) {
      return null;
    }
    return (
      <div style={{ marginTop: '20px', }}>
        <FieldSet title={title} style={{ maxHeight: '500px', }}>
          <Grid
            headers={headers}
            rows={rows}
            onRowSelect={row => this.onRowSelect(row)}
          />
        </FieldSet>
        {this.showSelectedInstallmentPlanInfo(selectedPlan)}
      </div>
    );
  }

  _setClickEvent(click) {
    this.click = click;
  }

  render() {
    const { customerId = '', installmentPlanData, } = this.state;
    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          defaultText={customerId}
          onClick={data => this.onClick(data)}
          clickConsumer={click => this._setClickEvent(click)}
        />
        {this.getGrid(installmentPlanData, 'Installment Plans')}
      </div>
    );
  }
}

ManagedPayView.defaultProps = {
  requestedState: undefined,
};

ManagedPayView.propTypes = {
  sendNavigationRequest: PropTypes.instanceOf(Function).isRequired,
  requestedState: PropTypes.string,
};

export default ManagedPayView;
